import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _isEqual from 'lodash/isEqual';
import _toLower from 'lodash/toLower';

import Toggler from 'components/Toggler';
import './style.scss';

export default class FilterMenuItemSwitch extends Component {
  static propTypes = {
    name: PropTypes.string,
    label: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    options: PropTypes.arrayOf(PropTypes.object),
    onToggle: PropTypes.func,
  };

  shouldComponentUpdate({ value }) {
    return !_isEqual(value, this.props.value);
  }

  handleToggle = value => {
    const { name, onToggle } = this.props;

    onToggle(value, name);
  };

  handleOnOff = (options, label) =>
    options.find(item => _toLower(item.label) === label).value;

  render() {
    const { label, value, options } = this.props;

    return (
      <Toggler
        styleName="toggler"
        label={label}
        value={value}
        onValue={this.handleOnOff(options, 'on')}
        offValue={this.handleOnOff(options, 'off')}
        onToggle={this.handleToggle}
      />
    );
  }
}
